












































































import { computed, defineComponent, reactive, ref } from "@vue/composition-api";
import Layout from "@/components/Atoms/Layout/index.vue";
import OccHeading from "@/components/Atoms/OccHeading/index.vue";
import OccButton from "@/components/Atoms/OccButton/index.vue";
import Pagination from "@/components/Atoms/Pagination/index.vue";
import PageHeader from "@/components/Molecules/PageHeader/index.vue";
import ListFilter from "@/components/Molecules/ListFilter/index.vue";
import FilterSection from "@/components/Molecules/FilterSection/index.vue";
import OccSearchMultiSelectbox from "@/components/Atoms/OccSearchMultiSelectbox/index.vue";
import OccSearchSelectbox from "@/components/Atoms/OccSearchSelectbox/index.vue";
import Checkbox from "@/components/Atoms/Forms/Checkbox/index.vue";
import SearchTextField from "@/components/Atoms/Forms/SearchTextField/index.vue";
import LoadingView from "@/components/Molecules/LoadingView/index.vue";
import { Props } from "@/components/Molecules/ListTable/index.vue";
import TableFooter from "@/components/Molecules/TableFooter/index.vue";
import SponsoredEventEntryCheckinsTable from "@/components/Organisms/SponsoredEventEntryCheckinsTable/index.vue";
import CsvCustomizeModal from "@/components/Organisms/CsvCustomizeModal/index.vue";
import ConfirmModal from "@/components/Organisms/modals/ConfirmModal/index.vue";
import DateRangeSelector from "@/components/Molecules/DateRangeSelector/index.vue";
import HelpLink from "@/components/Atoms/HelpLink/index.vue";
import CheckinFilter from "@/components/Organisms/CheckinFilter/index.vue";

// TODO: お気に入り更新API をワンキャリア主催イベントのAPIに置き換え
import {
  getSponsoredEventEntryCheckins,
  getSponsoredEventEntryCheckinSearchOptions,
  startGenerateEntryCheckinsCsv,
  getPartnerEntryCsvColumns,
  upsertPartnerEntryCsvColumns
} from "@/api";
import {
  PRIVILEGE_ENTRIES_DOWNLOAD,
  hasPrivilege
} from "@/helpers/privilege-helper";
import { useRequest } from "@/helpers/hooks/useRequest";
import { selectListGenerator } from "@/helpers/checkins";
import { pathQueryValueToArray } from "@/helpers/router-helper";
import { ApiRequest, ApiResponse, Order, EventFormat } from "@/api/types";
import { CsvColumns } from "@/components/Organisms/CsvCustomizeModal/types";
import { useRoute } from "@/router";
import { useStore } from "@/store";
import { CheckinUsersFilterData } from "@/components/Organisms/CheckinFilter/types";

export default defineComponent({
  name: "SponsoredEventEntryCheckins",
  components: {
    Layout,
    OccHeading,
    OccButton,
    Pagination,
    PageHeader,
    ListFilter,
    FilterSection,
    OccSearchMultiSelectbox,
    OccSearchSelectbox,
    Checkbox,
    SearchTextField,
    LoadingView,
    TableFooter,
    SponsoredEventEntryCheckinsTable,
    CsvCustomizeModal,
    ConfirmModal,
    DateRangeSelector,
    HelpLink,
    CheckinFilter
  },
  setup() {
    const route = useRoute();
    const store = useStore();
    /** ========================================
     * フィルタ
     * ========================================*/
    const filterState = ref<CheckinUsersFilterData>({
      keyword: "",
      eventIds: [],
      universities: [],
      graduateYears: [],
      grades: [],
      schedules: [],
      entryDate: { from: "", to: "" }
    });

    if (route.query.eventId) {
      filterState.value.eventIds = [Number(route.query.eventId)];
    }
    const queryParams = route.query;

    const [
      { data: searchOptions, loading: searchOptionsLoading },
      runGetSponsoredEventEntryCheckinSearchOptions
    ] = useRequest(
      () => getSponsoredEventEntryCheckinSearchOptions({ format: "online" }),
      {
        immediate: false
      }
    );

    const [
      { data: sponsoredEventEntryCheckins, loading: usersLoading },
      runGetSponsoredEventEntryCheckins
    ] = useRequest(
      () => {
        return getSponsoredEventEntryCheckins({
          ...searchParams.value,
          limit: displayCount.value,
          offset: displayCount.value * (currentPage.value - 1)
        });
      },
      { immediate: false }
    );

    const load = async () => {
      await runGetSponsoredEventEntryCheckinSearchOptions();
      await runGetSponsoredEventEntryCheckins();
      await restoreFilterStateFromQueryParams();
    };
    load();

    const headers = reactive<Props["headers"]>([
      {
        name: "ユーザー名",
        subHeaders: [{ name: "識別コード" }, { name: "カナ" }],
        sizeInner: "100px",
        minSizeContainer: "200px"
      },
      {
        name: "大学名",
        subHeaders: [{ name: "卒年" }, { name: "学年・学部" }],
        sizeInner: "220px",
        minSizeContainer: "220px"
      },
      {
        name: "申込イベント",
        minSizeContainer: "250px"
      },
      {
        name: "応募スケジュール",
        subHeaders: [{ name: "スケジュール開催日" }],
        minSizeContainer: "250px"
      },
      {
        name: "チェックイン日時",
        sortParam: "checkin_date",
        order: "desc",
        sizeInner: "130px",
        minSizeContainer: "170px"
      }
    ]);

    const hasCsvDownloadPriviledge = hasPrivilege(PRIVILEGE_ENTRIES_DOWNLOAD);

    // クエリパラメータから検索オプションを復元する
    const restoreFilterStateFromQueryParams = async () => {
      if (queryParams["schedules[]"]) {
        filterState.value.schedules = correctIdArrayParams(
          queryParams["schedules[]"],
          searchOptions.value?.schedules.map((obj: any) => obj.id)
        );
      }
      if (queryParams["events[]"]) {
        filterState.value.eventIds = correctIdArrayParams(
          queryParams["events[]"],
          searchOptions.value?.events.map((obj: any) => obj.id)
        );
      }
    };

    const correctIdArrayParams = (
      value: string | (string | null)[],
      selectableIds: number[] | undefined
    ) => {
      if (!selectableIds) {
        return [];
      }

      const correctArray = pathQueryValueToArray<string>(value);
      if (!correctArray) {
        return [];
      }

      return correctArray
        .map(v => Number(v))
        .filter(v => selectableIds.includes(v));
    };

    const scheduleSelectItemList = computed(() => {
      if (!searchOptions.value) return [];
      const schedules = searchOptions.value?.schedules;
      if (!schedules) return [];

      const tmpSchedulesItemList = schedules.map(
        (v: ApiResponse.PartnerEntryUserScheduleSelectItem) => {
          return {
            value: v.id,
            label: v.title
          };
        }
      );
      return tmpSchedulesItemList;
    });

    const eventSelectItemList = computed(() => {
      if (!searchOptions.value) return [];
      const events = searchOptions.value?.events;
      if (!events) return [];

      const tmpEventsItemList = events.map(
        (v: ApiResponse.PartnerEntryUserEventSelectItem) => {
          return {
            value: v.id,
            label: v.title
          };
        }
      );

      return tmpEventsItemList;
    });

    const selectItemList = computed(() => {
      return {
        universities: selectListGenerator(
          searchOptions.value?.universities || []
        ),
        graduateYears: selectListGenerator(
          searchOptions.value?.graduate_years || []
        ),
        grades: selectListGenerator(searchOptions.value?.grades || []),
        events: eventSelectItemList.value,
        schedules: scheduleSelectItemList.value
      };
    });

    const onSubmitFilter = async (newFilterState: CheckinUsersFilterData) => {
      filterState.value = newFilterState;
      moveFiresPage();
      await runGetSponsoredEventEntryCheckins();
    };

    const onResetFilter = async (newFilterState: CheckinUsersFilterData) => {
      filterState.value = newFilterState;
      moveFiresPage();
      await runGetSponsoredEventEntryCheckins();
    };

    /** ========================================
     * ページネーション
     * ========================================*/
    const currentPage = ref(1);

    const displayCount = ref(25);

    const displayCountSelectList = [
      { value: 25, label: "25件" },
      { value: 50, label: "50件" },
      { value: 100, label: "100件" },
      { value: 250, label: "250件" },
      { value: 500, label: "500件" }
    ];

    const totalPageCount = computed(() => {
      if (
        !sponsoredEventEntryCheckins.value ||
        !sponsoredEventEntryCheckins.value.total
      ) {
        return 1;
      }
      return Math.ceil(
        sponsoredEventEntryCheckins.value?.total / displayCount.value
      );
    });

    const moveFiresPage = () => {
      currentPage.value = 1;
    };

    const onChangePage = async (pageNumber: number) => {
      currentPage.value = pageNumber;
      await runGetSponsoredEventEntryCheckins();
    };

    const onChangeDisplayCount = async (count: number) => {
      displayCount.value = count;
      moveFiresPage();
      await runGetSponsoredEventEntryCheckins();
    };

    /** ========================================
     * ソート
     * ========================================*/
    const sortState = reactive<Pick<ApiRequest.SponsoredEvents, "order">>({
      order: "desc"
    });

    const onChangeOrder = async (order: Order, headerIndex: number) => {
      const targetHeader = headers[headerIndex];
      const sort = targetHeader.sortParam;

      if (!sort) {
        return;
      }

      sortState.order = order;
      targetHeader.order = order;
      moveFiresPage();

      await runGetSponsoredEventEntryCheckins();
    };

    /** ========================================
     * 行選択
     * ========================================*/
    const selectedRowList = ref<ApiResponse.SponsoredEventEntryCheckin[]>([]);

    const selectedRowCount = computed(() => selectedRowList.value.length);

    const onChangeRowValue = (
      list: ApiResponse.SponsoredEventEntryCheckin[]
    ) => {
      selectedRowList.value = list;
    };

    /** ========================================
     * アラート
     * ========================================*/
    const isLoading = computed<boolean>(() => {
      return !!usersLoading.value || !!searchOptionsLoading.value;
    });

    /** ========================================
     * CSV出力カラムの管理
     * ========================================*/
    const availableCsvColumns = [
      { name: "created_at", label: "チェックイン日時" },
      { name: "unique_id", label: "識別コード" },
      { name: "name", label: "名前" },
      { name: "name_kana", label: "名前（カナ）" },
      { name: "university_name", label: "大学" },
      { name: "department_name", label: "学部" },
      { name: "email", label: "大学メールアドレス" },
      { name: "internship_results", label: "インターン実績" },
      { name: "high_school", label: "出身高校名" },
      { name: "activities", label: "学生時代の活動実績" },
      { name: "tel", label: "電話番号" },
      { name: "unofficial_offer_results", label: "内定実績" },
      { name: "full_address", label: "住所" },
      { name: "date_of_birth", label: "生年月日" },
      { name: "grade", label: "学年" },
      { name: "graduate_year", label: "卒業年度" },
      { name: "concentration_name", label: "学科" },
      { name: "seminar_circle", label: "ゼミ・研究室" },
      { name: "course", label: "文理" },
      { name: "event_entry_state", label: "参加ステータス" },
      { name: "languages", label: "言語レベル" },
      { name: "self_promotion", label: "自己PR" },
      { name: "student_endeavor", label: "学生時代に頑張ったこと" },
      { name: "schedule", label: "イベント日程" },
      { name: "scheduled_at", label: "イベント開催日時" }
    ];

    const partnerEntryCsvColumns = ref<ApiResponse.PartnerEntryCsvColumn[]>();
    const excludedColumns = ref<CsvColumns[]>([]);
    const includedColumns = ref<CsvColumns[]>([]);

    const runGetPartnerEntryCsvColumns = async () => {
      const response = await getPartnerEntryCsvColumns();
      partnerEntryCsvColumns.value = response.data.csv_columns;
      updateDisplayCsvColumns();
    };

    const updateDisplayCsvColumns = () => {
      if (!partnerEntryCsvColumns.value) {
        return;
      }

      includedColumns.value = [];
      excludedColumns.value = [];

      partnerEntryCsvColumns.value.forEach(item => {
        const csvColumnObj = getCsvColumnObj(item.column);
        if (csvColumnObj) {
          includedColumns.value.push(csvColumnObj);
        }
      });

      excludedColumns.value = availableCsvColumns.filter(item => {
        return !includedColumns.value.find(includedCol => {
          return includedCol.name === item.name;
        });
      });
    };

    const getCsvColumnObj = (column: string) => {
      return availableCsvColumns.find(item => {
        return item.name === column;
      });
    };

    const csvColumnsSaveParams = computed(() => {
      const csvColumns = includedColumns.value.map((item, idx) => {
        return { column: item.name, position: idx };
      });
      if (
        partnerEntryCsvColumns.value?.find(
          item => item.column === "partner_entry_offer"
        )
      ) {
        const insertIndex = csvColumns.length;
        csvColumns.push({
          column: "partner_entry_offer",
          position: insertIndex
        });
      }
      // NOTE: entry_routeの出力カラムはチェックイン一覧では出力可能カラムに含まれない。
      //       応募者一覧では設定可能なため、併用している時誤って削除されないよう、登録されていれば保存時にも追加する。
      //       なお、チェックイン一覧におけるCSV出力時にはこの設定は無視される。
      if (
        partnerEntryCsvColumns.value?.find(
          item => item.column === "entry_route"
        )
      ) {
        const insertIndex = csvColumns.length;
        csvColumns.push({
          column: "entry_route",
          position: insertIndex
        });
      }

      return {
        csv_columns: csvColumns
      };
    });

    const runUpsertPartnerEntryCsvColumns = async () => {
      const response = await upsertPartnerEntryCsvColumns(
        csvColumnsSaveParams.value
      );
      if (response.status !== 204) {
        showCsvDownloadError();
      }
    };

    /** =======================================
     * CSVダウンロード
     * =======================================*/
    const onClickCsvDownload = () => {
      showCsvCustomizeModal();
    };
    const csvCustomizeModalShow = ref<boolean>(false);

    const closeCsvCustomizeModal = () => {
      csvCustomizeModalShow.value = false;
    };

    const showCsvCustomizeModal = async () => {
      await runGetPartnerEntryCsvColumns();
      csvCustomizeModalShow.value = true;
    };

    const csvDownloadConfirmModalShow = ref(false);

    const closeCsvDownloadConfirmModal = () => {
      csvDownloadConfirmModalShow.value = false;
    };

    const updateCsvIncludedColumns = (
      newArray: {
        name: string;
        label: string;
      }[]
    ) => {
      includedColumns.value = newArray;
    };
    const updateCsvExcludedColumns = (
      newArray: {
        name: string;
        label: string;
      }[]
    ) => {
      excludedColumns.value = newArray;
    };

    const searchParams = computed<ApiRequest.SponsoredEventEntryCheckinsBase>(
      () => {
        const params: ApiRequest.SponsoredEventEntryCheckinsBase = {
          format: "online" as EventFormat,
          keyword: filterState.value.keyword,
          starred: undefined,
          universities: filterState.value.universities,
          graduate_years: filterState.value.graduateYears,
          grades: filterState.value.grades,
          event_ids: filterState.value.eventIds,
          schedule_ids: filterState.value.schedules,
          order: sortState.order
        };

        // 以下はoptionalパラメータであるため、設定がある場合のみ追加する
        if (filterState.value.entryDate.from !== "") {
          params.entry_date_from = filterState.value.entryDate.from;
        }
        if (filterState.value.entryDate.to !== "") {
          params.entry_date_to = filterState.value.entryDate.to;
        }

        return params;
      }
    );

    const csvDownloadColumns = ref<string[]>();
    const csvDownloadParams = computed(() => {
      return {
        ...searchParams.value,
        output_columns: csvDownloadColumns.value || []
      };
    });

    const applyCsvDownload = async (items: string[]) => {
      await Promise.all([
        runUpsertPartnerEntryCsvColumns(),
        runCsvDownload(items)
      ]);
    };

    const runCsvDownload = async (items: string[]) => {
      csvDownloadColumns.value = items;
      const response = await startGenerateEntryCheckinsCsv(
        csvDownloadParams.value
      );
      if (response.status === 200) {
        csvDownloadConfirmModalShow.value = true;
      } else {
        showCsvDownloadError();
      }
    };

    const showCsvDownloadError = () => {
      store.commit("common/updateAlertView", {
        isVisible: true,
        title: "ダウンロードに失敗しました。リロードして再度お試しください。"
      });
    };

    return {
      searchOptions,
      sponsoredEventEntryCheckins,
      usersLoading,
      searchOptionsLoading,
      headers,
      hasCsvDownloadPriviledge,

      filterState,
      selectItemList,
      onSubmitFilter,
      onResetFilter,

      currentPage,
      displayCount,
      displayCountSelectList,
      totalPageCount,
      onChangePage,
      onChangeDisplayCount,

      onChangeOrder,

      selectedRowList,
      selectedRowCount,
      onChangeRowValue,

      isLoading,

      onClickCsvDownload,
      csvCustomizeModalShow,
      closeCsvCustomizeModal,
      showCsvCustomizeModal,
      csvDownloadConfirmModalShow,
      closeCsvDownloadConfirmModal,
      excludedColumns,
      includedColumns,
      applyCsvDownload,
      updateCsvIncludedColumns,
      updateCsvExcludedColumns
    };
  }
});
